import React from 'react'
import { DialogContent, Dialog } from '@mui/material'
import styled from 'styled-components'
import theme from 'styles/theme'

export default function AddedToLog(vars) {

  const { open } = vars
  return (
    <Dialog.Stylesheet
      open={open}
      disableEnforceFocus
    >
      <AddedToLog.Content>
        <div className="header">
          <h2>Exercise Added to Your Log</h2>
        </div>

        <div className="content">
          <h3>Head to the Logs Page to make any edits</h3>
        </div>

      </AddedToLog.Content>
    </Dialog.Stylesheet>
  )
}

Dialog.Stylesheet = styled(Dialog)``

AddedToLog.Content = styled(DialogContent)`
  padding: 3rem !important;
  max-width: 40rem;
  margin: 0 auto;
  .header {
    h2 {
      font-weight: 500;
      font-size: 2rem;
    }
  }
  .content {
    margin-top: 2rem;
    h3 {
      color: ${theme.palette.secondary.g800};
      font-size: 1.25rem;
      font-weight: 500;
    }
  }
`

AddedToLog.Stylesheet = styled.div`
  .MuiToolbar-root {
    justify-content: flex-start;
  }
`
